import { Container,Row,Col } from "react-bootstrap";
import Shopintegrate from "../../components/shop_integrate";


const Farmingintegrate=()=>{

return(<>
<Container>
    <div className="screenHeight">
<Shopintegrate newshop="/farming-form" url="/farming-integrate-form"/>
    </div>
</Container>

</>)

}

export default Farmingintegrate